import { ApiUrlUtil } from "../../utils/apiUrlUtil";
import Api from "app/services/common/Api";
import { Mhdlg } from "app/model/cp/Mhdlg";
import { FileInfoModel } from "app/model/common/file";
import {DocuBizPlnd, DocuBizSearchModel} from "app/model/cp/DocuBizPlnd";
import { DocuMoni } from "app/model/cp/DocuMoni";

export class MhdlgService extends Api {
  private static service: MhdlgService;
  private static DELETE_MANY_URL: string = process.env["REACT_APP_URL_CP"] + "/mhdlg/deleteList";
  private static GET_URL: string = process.env["REACT_APP_URL_CP"] + "/mhdlg/detail";
  private static DELETE_URL: string = process.env["REACT_APP_URL_CP"] + "/mhdlg/deleteRow";
  private static POST_URL: string = process.env["REACT_APP_URL_CP"] + "/mhdlg/save";
  private static GET_HEAD_DATA_URL: string = process.env["REACT_APP_URL_CP"] + "/bizplnd/header";
  private static FILE_URL: string = process.env["REACT_APP_URL_CP"] + "/files/file";
  private static DELETE_BUSINESS_URL: string = process.env["REACT_APP_URL_CP"] + "/bizplnd/deleteRow";
  private static GET_BUSINESS_URL: string = process.env["REACT_APP_URL_CP"] + "/bizplnd/detail";
  private static DELETE_MANY_BUSINESS_URL: string = process.env["REACT_APP_URL_CP"] + "/bizplnd/deleteList";
  private static POST_BUSINESS_URL: string = process.env["REACT_APP_URL_CP"] + "/bizplnd/save";
  private static POST_MONITORING_URL: string = process.env["REACT_APP_URL_CP"] + "/moni/save";
  private static DELETE_MONITORING_URL: string = process.env["REACT_APP_URL_CP"] + "/moni/deleteRow";
  private static GET_MONITORING_URL: string = process.env["REACT_APP_URL_CP"] + "/moni/detail";
  private static DELETE_MANY_MONITORING_URL: string = process.env["REACT_APP_URL_CP"] + "/moni/deleteList";

  public static getInstance(): MhdlgService {
    if (!MhdlgService.service) {
      MhdlgService.service = new MhdlgService();
    }
    return MhdlgService.service;
  }

  public async downloadFile(file: FileInfoModel) {
    const param = {
      filePath: file.pthNm,
      fileName: file.fileNm,
      originalFileName: file.realNm,
    };
    await super.download(MhdlgService.FILE_URL, param);
  }

  public async deleteMhdlgs(mhdlgs: Mhdlg[]) {
    return await super.post<Mhdlg[]>(MhdlgService.DELETE_MANY_URL, {
      deletedRows: mhdlgs,
    });
  }

  public async deleteMhdlg(mhdlg: Mhdlg) {
    var mhdlgId = mhdlg.mhdlgId;
    var mainFileId = null;
    var bizMainFileId = null;
    var moniMainFileId = null;

    if (mhdlg.file?.mainFileId != undefined || mhdlg.file?.mainFileId != null) {
      mainFileId = mhdlg.file?.mainFileId;
    }

    return await super.delete<Mhdlg>(MhdlgService.DELETE_URL, {
      mhdlgId: mhdlgId,
      mainFileId: mainFileId,
      bizMainFileId: bizMainFileId,
      moniMainFileId: moniMainFileId,
    });
  }

  public async getMhdlgDetail(mhdlgId: string) {
    return await super.get<Mhdlg>(MhdlgService.GET_URL, { mhdlgId: mhdlgId });
  }

  public async saveMhdlg(form: FormData) {
    return await super.post<Mhdlg>(MhdlgService.POST_URL, form);
  }

  public async getHeadData() {
    return await super.get(MhdlgService.GET_HEAD_DATA_URL);
  }

  public async deleteDocuBizPlnd(docuBizPlnd: DocuBizPlnd) {
    var docId = docuBizPlnd.docId;
    var mainFileId = null;
    if (
      docuBizPlnd.file?.mainFileId != undefined ||
      docuBizPlnd.file?.mainFileId != null
    ) {
      mainFileId = docuBizPlnd.file?.mainFileId;
    }
    return await super.delete<DocuBizPlnd>(MhdlgService.DELETE_BUSINESS_URL, {
      docId: docId,
      mainFileId: mainFileId,
      bizPlndFileId: docuBizPlnd?.bizPlndFileId
    });
  }

  public async deleteDocuBizPlnds(docuBizPlnds: DocuBizPlnd[]) {
    return await super.post<DocuBizPlnd[]>(
      MhdlgService.DELETE_MANY_BUSINESS_URL,
      {
        deletedRows: docuBizPlnds,
      }
    );
  }

  public async getDocuBizPlndDetail(docId: string) {
    return await super.get<DocuBizPlnd>(MhdlgService.GET_BUSINESS_URL, {
      docId: docId,
    });
  }

  public async saveDocBusiness(form: FormData) {
    return await super.post<DocuBizPlnd>(MhdlgService.POST_BUSINESS_URL, form);
  }

  // 모니터링
  public async deleteMoni(docuMoni: DocuMoni) {
    var docId = docuMoni.docId;
    var mainFileId = null;
    if (
        docuMoni.file?.mainFileId != undefined ||
        docuMoni.file?.mainFileId != null
    ) {
      mainFileId = docuMoni.file?.mainFileId;
    }
    return await super.delete<DocuBizPlnd>(MhdlgService.DELETE_MONITORING_URL, {
      docId: docId,
      mainFileId: mainFileId,
      moniFileId: docuMoni?.moniFileId
    });
  }

  public async getDocuMoniDetail(docId: string) {
    return await super.get<DocuMoni>(MhdlgService.GET_MONITORING_URL, {
      docId: docId,
    });
  }

  public async deleteMonis(docuMonis: DocuMoni[]) {
    return await super.post<DocuMoni[]>(
      MhdlgService.DELETE_MANY_MONITORING_URL,
      {
        deletedRows: docuMonis,
      }
    );
  }

  public async saveDocMonitoring(form: FormData) {
    return await super.post<DocuMoni>(
      MhdlgService.POST_MONITORING_URL,form);
  }

  public getReportData(id: string) {
    const url = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CP + "/ozreport?id="+id);
    return super.get(url);
  }

  public async getBizList(search: DocuBizSearchModel) {
    const url = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CP + "/bizplnd/list");
    return await super.get<any>(url, search);
  }

  public async getRoadmap() {
    const url = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CP + "/bizplnd/roadmap");
    return await super.get<number[]>(url);
  }

  public async getDetailList() {
    const url = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CP + "/bizplnd/detailList");
    return await super.get<DocuBizPlnd[]>(url);
  }
}
